export const UPDATE_UI = 'dashboard/ui/UPDATE_UI';
